import clsx from "clsx";
import {
  searchStore,
  SearchTabsProps,
} from "features/ProductSearch/SearchStore";
import { IconCube, IconStack2 } from "@tabler/icons-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";

function SearchTabList(props: {
  tabs: SearchTabsProps[];
  hideConcularProducts: boolean;
  onClickTab: (tab: SearchTabsProps) => void;
}) {
  const { t } = useTranslation();
  const tabList = props.tabs.map((tab: SearchTabsProps) => {
    return {
      ...tab,
      hidden: props.hideConcularProducts && tab.id.includes("concular"),
    };
  });

  function isTabHidden(tabID: string) {
    return tabID === "used_products" && !searchStore.hasAnyUsedProducts;
  }

  return (
    <div className="flex h-[36px] my-2 bg-white">
      {tabList.map((tab, index) => (
        <div
          key={tab.id}
          className={clsx(
            "flex flex-1 justify-center cursor-pointer  p-2 text-center items-center text-sm active:bg-gray-100",
            searchStore.selectedTab?.id === tab.id
              ? `bg-indigo-600 text-white`
              : `bg-white text-gray-900 border border-gray-200`,
            {
              "opacity-70 pointer-events-none !cursor-not-allowed":
                searchStore.productSearchLoading,
              "rounded-l-md": index === 0,
              "rounded-r-md": index === tabList.length - 1,
              hidden: tab.hidden || isTabHidden(tab.id),
            }
          )}
          onClick={() => props.onClickTab(tab)}
        >
          <span className="mr-2">
            {tab.type === "PRODUCT" ? (
              <IconCube width={18} />
            ) : (
              <IconStack2 width={18} />
            )}
          </span>
          {t(`mapping.${tab.id}`)}
        </div>
      ))}
    </div>
  );
}

export default observer(SearchTabList);
